import React, { Component, createRef } from 'react';
import ReactToPrint from 'react-to-print';

/**
 * Dev note:
 * This component is only temporary.
 * Delete this component after WEBAPPS-34273 work is done.
 */
class PrintContent extends Component {
	constructor(props) {
		super(props);

		this.componentRef = createRef();
	}

	onLoad = resp => {
		// trigger print after the image is loaded
		document.getElementById('printTrigger').click();
	};

	render() {
		const { imageURL, onAfterPrint } = this.props;

		return (
			<div className="return-label-print-content" style={{ display: 'none' }}>
				<ReactToPrint
					trigger={() => <button id="printTrigger" type="button" />}
					content={() => this.componentRef.current}
					onAfterPrint={onAfterPrint}
				/>

				<img
					ref={this.componentRef}
					style={{ width: '100%', height: '100%' }}
					src={imageURL}
					alt="return label"
					onLoad={this.onLoad}
				/>
			</div>
		);
	}
}

export default PrintContent;
